var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-654 -64)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(654 64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.167,13.625v-.708a1.415,1.415,0,0,0,1.41-1.417l.007-7.083A1.421,1.421,0,0,0,14.167,3H2.833A1.421,1.421,0,0,0,1.417,4.417V11.5a1.421,1.421,0,0,0,1.417,1.417v.708H0v1.417H17V13.625ZM2.833,4.417H14.167V11.5H2.833Z",
    transform: "translate(655 64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppOn);
export default __webpack_public_path__ + "static/media/icon_app_on.bdf41b2c64c9a1063f110fbb40cc0543.svg";
export { ForwardRef as ReactComponent };